import storage from '@/services/storage';
import { registerResetFn, resetAllStores } from '@/store/reset';
import { create } from 'zustand';
import { userSession } from '../helpers';

export interface AuthStore {
  isLoggedIn: boolean;
}

const initialState: AuthStore = {
  isLoggedIn: false,
};

export const useAuthStore = create<AuthStore>()(() => ({ ...initialState }));

registerResetFn(() => useAuthStore.setState(initialState));

export const logout = () => {
  storage.clearStorage();
  resetAllStores();
};

export const validateUser = async () => {
  try {
    const data = await userSession();
    useAuthStore.setState({ isLoggedIn: data != null });
  } catch {
    useAuthStore.setState({ isLoggedIn: false });
  }
};

export const invalidateSession = async () => {
  useAuthStore.setState({ isLoggedIn: false });
};

export const isLoggedInSelector = (state: AuthStore) => state.isLoggedIn;
